export default [{
  path: '/parcelamento/relpsn',
  component: {
    name: 'parcelamentoRelpSNBase',
    template: '<router-view />',
    meta: {
      resource: 'parcelamento_relpsn', //
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'parcelamento_relpsn-view',
    component: () => import('@/app/parcelamentos/parcelamento-relp/ParcelamentoRelp.vue'),
    meta: {
      tipo: 'relp',
      resource: 'parcelamento_relpsn', //
      action: 'read',
      navActiveLink: 'parcelamento_relpsn-view',
      pageTitle: 'Parcelamento RELP-SN',
      breadcrumb: [
        {
          text: 'Parcelamento RELP-SN',
          to: { name: 'parcelamento_relpsn-view' },
          active: true,
        },
      ],
    },
  }],
},
]
